<template>
    <div grey-back full-height>
        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack">
                <v-icon>arrow_back</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Barcode Design</v-toolbar-title>
            <!-- <v-spacer></v-spacer>
            <v-btn icon small @click="fn_saveTemplate" v-if="isFormValid" color="white">
                <v-icon>check</v-icon>
            </v-btn> -->
        </v-toolbar>

       <div class="hasToolbar hasFooter">
             <v-card flat v-if="false">
                <v-card-text nopadding>
                    <!-- Configuration Name -->
                    <v-card class="mb-4" style="margin-top: 60px;">
                        <v-card-title class="pb-2">Configuration Name</v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 class="px-2 mb-3">
                                    <v-text-field
                                        v-model="config.name"
                                        label="Config Name"
                                        outlined
                                        dense
                                        placeholder="e.g., Standard Label Config"
                                        v-validate="'required'"
                                        data-vv-name="configName"
                                        :error-messages="errors.collect('configName')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>

                    <!-- Paper Settings -->
                    <v-card class="mb-4" v-if="false">
                        <v-card-title class="pb-2">
                            <v-icon left>receipt</v-icon>Paper Settings
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <!-- Paper Size -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.paperSettings.paperSize"
                                        :items="paperSizes"
                                        label="Paper Size"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                        v-validate="'required'"
                                        data-vv-name="paperSize"
                                        :error-messages="errors.collect('paperSize')"
                                    ></v-select>
                                </v-flex>

                                <!-- Paper Orientation -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.paperSettings.orientation"
                                        :items="['Portrait', 'Landscape']"
                                        label="Orientation"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex>

                                <!-- Margin Top -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.marginTop"
                                        label="Margin Top (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        @input="fn_updatePreview"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Margin Left -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.marginLeft"
                                        label="Margin Left (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        @input="fn_updatePreview"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Label Width -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.labelWidth"
                                        label="Label Width (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="1"
                                        @input="fn_updatePreview"
                                        v-validate="'required|numeric|min_value:1'"
                                        data-vv-name="labelWidth"
                                        :error-messages="errors.collect('labelWidth')"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Label Height -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.labelHeight"
                                        label="Label Height (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="1"
                                        @input="fn_updatePreview"
                                        v-validate="'required|numeric|min_value:1'"
                                        data-vv-name="labelHeight"
                                        :error-messages="errors.collect('labelHeight')"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Horizontal Gap -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.horizontalGap"
                                        label="Horizontal Gap (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        @input="fn_updatePreview"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Vertical Gap -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.verticalGap"
                                        label="Vertical Gap (mm)"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        @input="fn_updatePreview"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Label Count -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.paperSettings.labelCount"
                                        label="Label Count Per Page"
                                        outlined
                                        dense
                                        type="number"
                                        min="1"
                                        @input="fn_updatePreview"
                                        v-validate="'required|numeric|min_value:1'"
                                        data-vv-name="labelCount"
                                        :error-messages="errors.collect('labelCount')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>

                    <!-- Label Settings -->
                    <v-card class="mb-4" v-if="false">
                        <v-card-title class="pb-2">
                            <v-icon left>text_fields</v-icon>Label Settings
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <!-- Vertical Alignment -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.verticalAlign"
                                        :items="['Top', 'Middle', 'Bottom']"
                                        label="Vertical Alignment"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex>

                                <!-- Horizontal Alignment -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.horizontalAlign"
                                        :items="['Left', 'Center', 'Right']"
                                        label="Horizontal Alignment"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex>

                                <!-- Label Width (Content) -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.labelSettings.contentWidth"
                                        label="Content Width (%)"
                                        outlined
                                        dense
                                        type="number"
                                        min="10"
                                        max="100"
                                        @input="fn_updatePreview"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Font Size -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-text-field
                                        v-model.number="config.labelSettings.fontSize"
                                        label="Font Size (pt)"
                                        outlined
                                        dense
                                        type="number"
                                        min="6"
                                        max="72"
                                        @input="fn_updatePreview"
                                        v-validate="'required|numeric|min_value:6|max_value:72'"
                                        data-vv-name="fontSize"
                                        :error-messages="errors.collect('fontSize')"
                                    ></v-text-field>
                                </v-flex>

                                <!-- Font Style -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.fontStyle"
                                        :items="fontStyles"
                                        label="Font Style"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex>

                                <!-- Font Weight -->
                                <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.fontWeight"
                                        :items="['Normal', 'Bold']"
                                        label="Font Weight"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex>

                                <!-- Text Color -->
                                <!-- <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.textColor"
                                        :items="textColors"
                                        label="Text Color"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex> -->

                                <!-- Background Color -->
                                <!-- <v-flex xs12 sm6 class="px-2 mb-3">
                                    <v-select
                                        v-model="config.labelSettings.backgroundColor"
                                        :items="bgColors"
                                        label="Background Color"
                                        outlined
                                        dense
                                        @change="fn_updatePreview"
                                    ></v-select>
                                </v-flex> -->
                            </v-layout>
                        </v-card-text>
                    </v-card>

                    <!-- Custom Fields Settings -->
                    <v-card class="mb-4" v-if="false">
                        <v-card-title class="pb-2">
                            <v-icon left>add_box</v-icon>Custom Fields
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <!-- Field Name Selection -->
                                <v-flex :class="[newField.fieldName == 'Text' ? 'sm6 md6' : 'sm12 md12']" class="px-2 mb-3">
                                    <v-select
                                        v-model="newField.fieldName"
                                        :items="availableFields"
                                        label="Select Field Name"
                                        outlined
                                        dense
                                        placeholder="e.g., Category, Brand, etc."
                                    ></v-select>
                                </v-flex>

                                <!-- Field Value -->
                                <v-flex xs6 sm6 class="px-2 mb-3" v-if="newField.fieldName == 'Text'">
                                    <v-text-field
                                        v-model="newField.fieldValue"
                                        label="Field Value"
                                        outlined
                                        dense
                                        placeholder="e.g., Cloths"
                                    ></v-text-field>
                                </v-flex>

                            <template v-if="showMoreFields">
                                    <!-- Layout Direction -->
                                    <v-flex xs12 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.layoutDirection"
                                            :items="['Horizontal', 'Vertical']"
                                            label="Layout Direction"
                                            outlined
                                            dense
                                        ></v-select>
                                    </v-flex>

                                    <!-- X-Axis Alignment -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.xAxisAlignment"
                                            :items="['Start', 'Center', 'End']"
                                            label="X-Axis Alignment"
                                            outlined
                                            dense
                                            hint="Left (Start), Center, Right (End)"
                                            persistent-hint
                                        ></v-select>
                                    </v-flex> -->

                                    <!-- Y-Axis Alignment -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.yAxisAlignment"
                                            :items="['Start', 'Center', 'End']"
                                            label="Y-Axis Alignment"
                                            outlined
                                            dense
                                            hint="Top (Start), Center, Bottom (End)"
                                            persistent-hint
                                        ></v-select>
                                    </v-flex> -->

                                    <!-- X-Axis Position (Numeric) -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-text-field
                                            v-model.number="newField.xAxisPosition"
                                            label="X-Axis Position (px)"
                                            outlined
                                            dense
                                            type="number"
                                            hint="Numeric position in pixels (0 = use alignment)"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-flex> -->

                                    <!-- Y-Axis Position (Numeric) -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-text-field
                                            v-model.number="newField.yAxisPosition"
                                            label="Y-Axis Position (px)"
                                            outlined
                                            dense
                                            type="number"
                                            hint="Numeric position in pixels (0 = use alignment)"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-flex> -->

                                    <v-flex xs12 sm12 pt-3 pb-3 class="px-2">
                                        Text Styles
                                    </v-flex>

                                    <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-text-field
                                            v-model.number="newField.fontSize"
                                            label="Font Size (px)"
                                            outlined
                                            dense
                                            type="number"
                                            min="6"
                                            max="72"
                                            @input="fn_updatePreview"
                                            v-validate="'required|numeric|min_value:6|max_value:72'"
                                            data-vv-name="fontSize"
                                            :error-messages="errors.collect('fontSize')"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.fontStyle"
                                            :items="fontStyles"
                                            label="Font Style"
                                            outlined
                                            dense
                                            @change="fn_updatePreview"
                                        ></v-select>
                                    </v-flex>

                                    <!-- Font Weight -->
                                    <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.fontWeight"
                                            :items="['Normal', 'Bold']"
                                            label="Font Weight"
                                            outlined
                                            dense
                                            @change="fn_updatePreview"
                                        ></v-select>
                                    </v-flex>

                                    <!-- Text Color -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.textColor"
                                            :items="textColors"
                                            label="Text Color"
                                            outlined
                                            dense
                                            @change="fn_updatePreview"
                                        ></v-select>
                                    </v-flex> -->

                                    <!-- Background Color -->
                                    <!-- <v-flex xs6 sm6 class="px-2 mb-3">
                                        <v-select
                                            v-model="newField.backgroundColor"
                                            :items="bgColors"
                                            label="Background Color"
                                            outlined
                                            dense
                                            @change="fn_updatePreview"
                                        ></v-select>
                                    </v-flex> -->
                            </template>

                                <!-- <v-flex xs12 sm12>
                                    <v-btn
                                        color="primary"
                                        block
                                        flat
                                        @click="showMoreFields = !showMoreFields"
                                    >
                                        {{ showMoreFields ? 'Less' : 'More' }} Configurations
                                    </v-btn>
                                </v-flex> -->

                                <!-- Add Button -->
                                <v-flex xs12 class="px-2 mb-3">
                                    <v-btn color="primary" @click="fn_addCustomField" block outlined>
                                        <v-icon left>add</v-icon>Add Field to Label
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>

            <!-- Preview Section (Fixed on the right) -->
            <v-card flat class="preview-card" v-if="isFormValid">
                <!-- <v-card-title class="pb-2 d-flex align-center">
                    <v-icon left>visibility</v-icon>
                    <span>Preview</span>
                    <v-spacer></v-spacer>
                    <v-btn-group small>
                        <v-btn 
                            color="primary"
                            @click="generateBarcode"
                            small
                            outlined
                        >
                            <v-icon small>barcode</v-icon>
                        </v-btn>

                        <v-btn 
                            :color="previewMode === 'single' ? 'primary' : 'grey lighten-2'"
                            @click="previewMode = 'single'"
                            small
                            outlined
                        >
                            <v-icon small>label</v-icon>
                        </v-btn>
                        <v-btn 
                            :color="previewMode === 'fullPage' ? 'primary' : 'grey lighten-2'"
                            @click="previewMode = 'fullPage'"
                            small
                            outlined
                            title="Print Preview"
                        >
                            <v-icon small>print</v-icon>
                        </v-btn>
                    </v-btn-group>
                </v-card-title> -->
                <!-- <v-btn @click="labelPreview = !labelPreview">{{ labelPreview ? 'Hide' : 'Show' }} Preview</v-btn> -->
                <v-btn @click="fn_openPreview">Preview</v-btn>
                <v-card-text class="pa-0 pt-2" style="background-color: #f5f5f5; overflow-y: auto;">
                    <!-- Ruler Unit Toggle -->
                    <!-- <div style="display: flex; justify-content: center; margin-bottom: 15px; gap: 8px;">
                        <v-btn-group small>
                            <v-btn 
                                :color="rulerUnit === 'px' ? 'primary' : 'grey lighten-2'"
                                @click="rulerUnit = 'px'"
                                small
                                outlined
                            >
                                PX
                            </v-btn>
                            <v-btn 
                                :color="rulerUnit === 'mm' ? 'primary' : 'grey lighten-2'"
                                @click="rulerUnit = 'mm'"
                                small
                                outlined
                            >
                                MM
                            </v-btn>
                            <v-btn 
                                :color="rulerUnit === 'cm' ? 'primary' : 'grey lighten-2'"
                                @click="rulerUnit = 'cm'"
                                small
                                outlined
                            >
                                CM
                            </v-btn>
                        </v-btn-group>
                    </div> -->

                    <!-- Single Label Preview -->
                    <div v-if="previewMode === 'single'" style="display: flex; justify-content: center;">
                        <div class="ruler-wrapper">
                            <!-- Top X-Axis Ruler -->
                            <div class="ruler ruler-x" :style="{ width: getSingleLabelPreviewStyle().width }">
                                <div v-for="i in Math.ceil(parseInt(getSingleLabelPreviewStyle().width) / getRulerTickInterval())" :key="'x-' + i" class="tick" :style="{ left: (i * getRulerTickInterval()) + 'px' }">
                                    <div class="tick-mark"></div>
                                    <span v-if="i % getRulerLabelInterval() === 0" class="tick-label">{{ getRulerLabel(i) }}</span>
                                </div>
                            </div>
                            
                            <div style="display: flex;">
                                <!-- Left Y-Axis Ruler -->
                                <div class="ruler ruler-y" :style="{ height: getSingleLabelPreviewStyle().height }">
                                    <div v-for="i in Math.ceil(parseInt(getSingleLabelPreviewStyle().height) / getRulerTickInterval())" :key="'y-' + i" class="tick" :style="{ top: (i * getRulerTickInterval()) + 'px' }">
                                        <div class="tick-mark"></div>
                                        <span v-if="i % getRulerLabelInterval() === 0" class="tick-label">{{ getRulerLabel(i) }}</span>
                                    </div>
                                </div>
                                
                                <!-- Canvas with Labels -->
                                <div class="label-preview canvas" :style="getSingleLabelPreviewStyle()">
                                    <div id="guideX" class="guide v"></div>
                                    <div id="guideY" class="guide h"></div>
                            
                            <div :style="getSinglePreviewContentStyle()">
                                <!-- <p style="margin: 4px 0; font-size: 14px;">Sample Item</p>
                                <p style="margin: 4px 0; font-size: 12px;">Product Code: 123456</p> -->
                                
                                <!-- <div style="margin: 8px 0; padding: 6px; background-color: #eee; border-radius: 3px; font-family: monospace; font-size: 13px;">
                                    ▓▄▓▓▄ ▄▄▓ ▓ ▄▓
                                </div> -->

                                <!-- <div>
                                    <img id="barcode"/>
                                </div> -->
                                <!-- <p style="margin: 4px 0; font-size: 12px;">Price: $99.99</p> -->
                            </div>
                            
                                    <!-- Custom Fields Display -->
                                    <template>
                                        <div v-for="(field, index) in config.customFields" class="draggable" :key="'custom-' + field.fieldName" :id="field.fieldName + '_' + (index + 1)" :style="getSingleCustomFieldStyle(field)">
                                            <span>{{ field.fieldName != 'Text' ? field.fieldName : '' }}{{ field.fieldName != 'Text' && field.fieldValue ? ':' : '' }}</span>
                                            <span style="margin-left: 4px;" v-if="field.fieldValue">{{ field.fieldValue }}</span>
                                        </div>
                                    </template>

                                    <!-- <template v-else>
                                        <div v-for="(field, index) in config.customFields" class="draggable" :key="'custom-' + field.fieldName" :id="field.fieldName + '_' + (index + 1)" :style="getSingleCustomFieldStyle(field)">
                                            <span>{{ field.fieldName != 'Text' ? fn_mapFieldValue(field.fieldName) : '' }}{{ field.fieldValue ? ':' : '' }}</span>
                                            <span style="margin-left: 4px;" v-if="field.fieldValue">{{ field.fieldValue }}</span>
                                        </div>
                                    </template> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Full Page Print Preview -->
                    <!-- <div v-if="previewMode === 'fullPage'" style="display: flex; justify-content: center; padding: 10px;">
                        <div class="label-preview-container" :style="getPreviewContainerStyle()">
                            <div v-for="labelIndex in calculatedLabelsPerPage" 
                                :key="'label-' + labelIndex"
                                class="label-preview"
                                :style="getPreviewLabelStyle()">
                                <div :style="getPreviewContentStyle()">
                                    <p style="margin: 4px 0; font-size: 11px;">Sample Item</p>
                                    <p style="margin: 4px 0; font-size: 10px;">Product Code: 123456</p>
                                    
                                    <div style="margin: 6px 0; padding: 4px; background-color: #eee; border-radius: 2px; font-family: monospace; font-size: 9px;">
                                        ▓▄▓▓▄ ▄▄▓ ▓ ▄▓
                                    </div>
                                    <p style="margin: 4px 0; font-size: 9px;">Price: $99.99</p>
                                </div>
                                
                                <div v-for="field in config.customFields" :key="'custom-' + field.fieldName" :style="getCustomFieldStyle(field)">
                                    <span style="font-size: 8px; font-weight: bold;">{{ field.fieldName }}:</span>
                                    <span style="font-size: 8px; margin-left: 2px;">{{ field.fieldValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <v-card flat>
                        <v-card-text>
                            <v-divider v-if="config.customFields.length > 0" class="my-3"></v-divider>
                            <v-expansion-panel v-if="config.customFields.length > 0" accordion>
                                <v-expansion-panel-content v-for="(field, index) in config.customFields" :key="'field-' + index">
                                    <div class="py-0" slot="header">
                                        <div class="py-2">
                                            <strong>{{ field.fieldName }}:</strong> {{ field.fieldValue }}
                                            <v-chip small class="ml-2" :color="field.layoutDirection === 'Horizontal' ? 'blue lighten-2' : 'orange lighten-2'">
                                                {{ field.layoutDirection }}
                                            </v-chip>
                                        </div>
                                    </div>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 class="px-2">
                                                <p><strong>Field:</strong> {{ field.fieldName }}</p>
                                                <p><strong>Value:</strong> {{ field.fieldValue }}</p>
                                                <p><strong>Direction:</strong> {{ field.layoutDirection }}</p>
                                            </v-flex>
                                            <v-flex xs6 class="px-2">
                                                <p><strong>X-Axis:</strong> {{ field.xAxisAlignment }} <span class="grey--text" v-if="field.xAxisPosition !== 0">(Pos: {{ field.xAxisPosition }}px)</span></p>
                                                <p><strong>Y-Axis:</strong> {{ field.yAxisAlignment }} <span class="grey--text" v-if="field.yAxisPosition !== 0">(Pos: {{ field.yAxisPosition }}px)</span></p>
                                            </v-flex>
                                            <v-flex xs6 class="px-2">
                                                <p><strong>X-Axis Pos:</strong> {{ field.xAxisPosition }} <span class="grey--text" v-if="field.xAxisPosition !== 0">(Pos: {{ field.xAxisPosition }}px)</span></p>
                                                <p><strong>Y-Axis Pos:</strong> {{ field.yAxisPosition }} <span class="grey--text" v-if="field.yAxisPosition !== 0">(Pos: {{ field.yAxisPosition }}px)</span></p>
                                            </v-flex>
                                            <v-flex xs12 class="px-2 mt-3">
                                                <v-btn small @click="fn_removeCustomField(index)" block outlined>
                                                    <v-icon left small>delete</v-icon>Remove Field
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-card-text>
                    </v-card> -->

                    <!-- Configuration Summary -->
                    <!-- <v-card class="mt-4" style="background-color: white;">
                        <v-card-text class="pa-2">
                            <p><strong>Paper:</strong> {{ config.paperSettings.paperSize }} ({{ config.paperSettings.orientation }})</p>
                            <p><strong>Paper Dimension:</strong> {{ paperDimensions[config.paperSettings.paperSize].width }}mm × {{ paperDimensions[config.paperSettings.paperSize].height }}mm</p>
                            <p><strong>Label Size:</strong> {{ config.paperSettings.labelWidth }}mm × {{ config.paperSettings.labelHeight }}mm</p>
                            <p><strong>Margins:</strong> Top {{ config.paperSettings.marginTop }}mm, Left {{ config.paperSettings.marginLeft }}mm</p>
                            <p><strong>Gaps:</strong> H {{ config.paperSettings.horizontalGap }}mm, V {{ config.paperSettings.verticalGap }}mm</p>
                            <p><strong>Calculated Layout:</strong> {{ calculatedColumns }} columns × {{ calculatedRows }} rows = {{ calculatedLabelsPerPage }} labels per page</p>
                            <p><strong>Font:</strong> {{ config.labelSettings.fontSize }}pt {{ config.labelSettings.fontStyle }} ({{ config.labelSettings.fontWeight }})</p>
                            <p><strong>Alignment:</strong> {{ config.labelSettings.verticalAlign }} / {{ config.labelSettings.horizontalAlign }}</p>
                            <div v-if="config.customFields.length > 0" class="mt-2 pt-2" style="border-top: 1px solid #eee;">
                                <p><strong>Custom Fields:</strong></p>
                                <div v-for="field in config.customFields" :key="'summary-' + field.fieldName" class="ml-2" style="font-size: 12px;">
                                    <span class="blue--text">{{ field.fieldName }}:</span> {{ field.fieldValue }} 
                                    <span class="grey--text text--lighten-1">({{ field.layoutDirection }}, X:{{ field.xAxisAlignment }}{{ field.xAxisPosition !== 0 ? ' (' + field.xAxisPosition + 'px)' : '' }} Y:{{ field.yAxisAlignment }}{{ field.yAxisPosition !== 0 ? ' (' + field.yAxisPosition + 'px)' : '' }})</span>
                                    {{ field.posLeft !== 0 || field.posTop !== 0 ? ' (Pos: ' + field.posLeft + 'px, ' + field.posTop + 'px)' : '' }}
                                </div>
                            </div>
                        </v-card-text>
                    </v-card> -->
                </v-card-text>
            </v-card>

            <v-footer style="position: fixed; bottom: 0; left: 0; right: 0; background-color: #fff; border-top: 1px solid #ddd;height: 48px;">
                <v-layout row wrap center-align>
                    <v-flex xs6 sm6 md6 style="border-right: 1px #ddd solid;">
                        <v-btn block flat capitalize light-theme-color @click="fn_openFieldSelection(true)"><v-icon font16 light-opacity-color class="mr-1">edit</v-icon> Add &amp; Customize</v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                        <v-btn block flat color="primary" @click="fn_openFieldSelection(false)"><v-icon font20 color="primary" class="mr-1">add</v-icon> Add Field</v-btn>
                    </v-flex>
                </v-layout>
            </v-footer>
       </div>

        <!-- Action Buttons -->
        <!-- <v-card flat class="mt-4 mb-4">
            <v-card-text class="text-xs-center">
                <v-btn color="success" @click="fn_saveTemplate" 
                       :disabled="!isFormValid"
                       class="mr-2">
                    <v-icon left>save</v-icon>Save Template
                </v-btn>
                <v-btn color="primary" @click="fn_resetForm" 
                       outlined class="mr-2">
                    <v-icon left>refresh</v-icon>Reset
                </v-btn>
                <v-btn color="secondary" @click="fn_goBack" outlined>
                    <v-icon left>arrow_back</v-icon>Cancel
                </v-btn>
            </v-card-text>
        </v-card> -->

        <dialog-preview ref="ref_dialogPreview" />
        <dialog-config ref="ref_dialogConfig" />

        <v-dialog
            v-model="dialogFieldSelection"
            scrollable
            max-width="500px"
            transition="dialog-bottom-transition"
            v-if="dialogFieldSelection"
        >
            <v-card flat>
                <v-card-title class="pb-2 noshadow" style="border-bottom: 1px solid #ddd;">
                    <span>Select Field</span>
                    <v-spacer></v-spacer>
                    <v-btn class="ma-0 pa-0" icon @click="dialogFieldSelection = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text nopadding>
                    <v-list>

                        <v-list-tile @click="fn_pickImage">
                            <v-list-tile-content>
                                <v-list-tile-title class="primary-color">Add Image</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile @click="fn_addCustomField(item)" v-for="(item, index) in availableFields" :key="index">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon>radio_button_unchecked</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import dialogConfig from './dialog_barcode_config';
import dialogPreview from './dialog_barcode_preview';
export default {
    name: 'barcode_label_config',
    components: {
        dialogPreview,
        dialogConfig
    },
    data() {
        return {
            config: {
                name: 'A',
                paperSettings: {
                    paperSize: 'A4',
                    orientation: 'Portrait',
                    marginTop: 10,
                    marginLeft: 10,
                    labelWidth: 100,
                    labelHeight: 44,
                    horizontalGap: 2,
                    verticalGap: 2,
                    labelCount: 65
                },
                labelSettings: {
                    verticalAlign: 'Middle',
                    horizontalAlign: 'Center',
                    contentWidth: 90,
                    fontSize: 16,
                    fontFamily: 'Arial',
                    fontWeight: 'Normal',
                    fontStyle: 'Normal',
                    textColor: '#000000',
                    backgroundColor: '#FFFFFF'
                },
                customFields: []
            },
            newField: {
                fieldName: '',
                fieldValue: '',
                layoutDirection: 'Horizontal',
                xAxisAlignment: 'Center',
                yAxisAlignment: 'Center',
                xAxisPosition: 0,
                yAxisPosition: 0,
                posLeft: 0,
                posTop: 0,
                fontSize: 16,
                fontStyle: 'Arial',
                fontWeight: 'Normal',
                fontStyle: 'Normal',
                textColor: '#000000',
                backgroundColor: '#FFFFFF',
                fieldType:'Label',
                imgWidth:null,
                imgHeight:null,
            },
            paperSizes: [
                'A3',
                'A4',
                'A5',
                'Letter',
                'Legal'
            ],
            fontStyles: [
                'Arial',
                'Times New Roman',
                'Courier New',
                'Verdana',
                'Georgia'
            ],
            availableFields: [
                'Item Name',
                'Product Code',
                'Barcode',
                'Category',
                'Brand',
                'Size',
                'Color',
                'SKU',
                'MRP',
                'Rate',
                'Discount',
                'Expiry Date',
                'Batch No',
                'Quantity',
                'Unit',
                'Manufacturer',
                'Text',
                'Custom 1',
                'Custom 2',
                'Custom 3'
            ],
            availableFieldMappings: {
                'Item Name': 'Sample Item',
                'Product Code': 'ABC123',
                'Barcode': 'barcode',
                'Category': 'Fashion & Cloth',
                'Brand': 'Wrogn',
                'Size': '32',
                'Color': 'Blue',
                'SKU': 'sku',
                'MRP': '2250',
                'Rate': '1900',
                'Discount': '10%',
                'Expiry Date': 'expiryDate',
                'Batch No': '1122/20/4',
                'Quantity': '1',
                'Unit': 'Pcs',
                'Manufacturer': 'Wrogn Pvt Ltd',
            },
            textColors: [
                { text: 'Black', value: '#000000' },
                { text: 'White', value: '#FFFFFF' },
                { text: 'Red', value: '#FF0000' },
                { text: 'Blue', value: '#0000FF' },
                { text: 'Green', value: '#00AA00' }
            ],
            bgColors: [
                { text: 'White', value: '#FFFFFF' },
                { text: 'Light Gray', value: '#F5F5F5' },
                { text: 'Yellow', value: '#FFFF00' },
                { text: 'Light Blue', value: '#ADD8E6' }
            ],
            paperDimensions: {
                'A3': { width: 297, height: 420 },
                'A4': { width: 210, height: 297 },
                'A5': { width: 148, height: 210 },
                'Letter': { width: 215.9, height: 279.4 },
                'Legal': { width: 215.9, height: 355.6 }
            },
            previewMode: 'single',  // 'single' or 'fullPage'
            rulerUnit: 'mm',  // 'px', 'cm', or 'mm'
            rulerDPI: 96,  // Standard web DPI,
            showMoreFields: false,
            labelPreview:false,
            dialogFieldSelection:false,
            isEditField:false
        };
    },
    computed: {
        isFormValid() {
            return this.config.name && 
                   this.config.name.trim() !== '' &&
                   this.config.paperSettings.labelWidth > 0 &&
                   this.config.paperSettings.labelHeight > 0 &&
                   this.config.paperSettings.labelCount > 0 &&
                   this.config.labelSettings.fontSize >= 6;
        },
        calculatedLabelsPerPage() {
            const dims = this.paperDimensions[this.config.paperSettings.paperSize];
            if (!dims) return 1;
            
            let width = this.config.paperSettings.orientation === 'Landscape' ? dims.height : dims.width;
            let height = this.config.paperSettings.orientation === 'Landscape' ? dims.width : dims.height;
            
            const availableWidth = width - (this.config.paperSettings.marginLeft * 2);
            const availableHeight = height - (this.config.paperSettings.marginTop * 2);
            
            if (availableWidth <= 0 || availableHeight <= 0) return 1;
            
            const columns = Math.floor(
                (availableWidth + this.config.paperSettings.horizontalGap) / 
                (this.config.paperSettings.labelWidth + this.config.paperSettings.horizontalGap)
            );
            
            const rows = Math.floor(
                (availableHeight + this.config.paperSettings.verticalGap) / 
                (this.config.paperSettings.labelHeight + this.config.paperSettings.verticalGap)
            );
            
            return Math.max(1, columns * rows);
        },
        calculatedColumns() {
            const dims = this.paperDimensions[this.config.paperSettings.paperSize];
            if (!dims) return 3;
            
            let width = this.config.paperSettings.orientation === 'Landscape' ? dims.height : dims.width;
            const availableWidth = width - (this.config.paperSettings.marginLeft * 2);
            
            if (availableWidth <= 0) return 1;
            
            const columns = Math.floor(
                (availableWidth + this.config.paperSettings.horizontalGap) / 
                (this.config.paperSettings.labelWidth + this.config.paperSettings.horizontalGap)
            );
            
            return Math.max(1, columns);
        },
        calculatedRows() {
            const dims = this.paperDimensions[this.config.paperSettings.paperSize];
            if (!dims) return 3;
            
            let height = this.config.paperSettings.orientation === 'Landscape' ? dims.width : dims.height;
            const availableHeight = height - (this.config.paperSettings.marginTop * 2);
            
            if (availableHeight <= 0) return 1;
            
            const rows = Math.floor(
                (availableHeight + this.config.paperSettings.verticalGap) / 
                (this.config.paperSettings.labelHeight + this.config.paperSettings.verticalGap)
            );
            
            return Math.max(1, rows);
        }
    },
    methods: {
        fn_updatePreview() {
            this.$forceUpdate();
        },

        // Ruler unit conversion methods
        pxToMm(px) {
            // 1 inch = 25.4 mm, 1 inch = 96 pixels (standard DPI)
            return (px * 25.4) / this.rulerDPI;
        },
        pxToCm(px) {
            return this.pxToMm(px) / 10;
        },
        mmToPx(mm) {
            return (mm * this.rulerDPI) / 25.4;
        },
        getRulerTickInterval() {
            // Return interval in pixels based on current unit
            switch(this.rulerUnit) {
                case 'mm':
                    return this.mmToPx(5); // 5mm intervals
                case 'cm':
                    return this.mmToPx(10); // 1cm intervals
                case 'px':
                default:
                    return 10; // 10px intervals
            }
        },
        getRulerLabelInterval() {
            // Return label interval multiplier (show label every Nth tick)
            switch(this.rulerUnit) {
                case 'mm':
                    return 2; // Show every 10mm
                case 'cm':
                    return 1; // Show every 1cm
                case 'px':
                default:
                    return 5; // Show every 50px
            }
        },
        getRulerLabel(index) {
            const tickInterval = this.getRulerTickInterval();
            const px = index * tickInterval;
            
            switch(this.rulerUnit) {
                case 'mm':
                    return Math.round(this.pxToMm(px));
                case 'cm':
                    return (this.pxToCm(px)).toFixed(1);
                case 'px':
                default:
                    return index * 10;
            }
        },

        getPositionByAxis(yAlign, xAlign) {
            const positions = {};
            
            // Y-axis positioning
            if (yAlign === 'Top') {
                positions.top = '2px';
            } else if (yAlign === 'Middle') {
                positions.top = '50%';
                positions.transform = 'translateY(-50%)';
            } else if (yAlign === 'Bottom') {
                positions.bottom = '2px';
            }
            
            // X-axis positioning
            if (xAlign === 'Left') {
                positions.left = '2px';
            } else if (xAlign === 'Center') {
                positions.left = '50%';
                positions.transform = positions.transform ? 'translateY(-50%) translateX(-50%)' : 'translateX(-50%)';
            } else if (xAlign === 'Right') {
                positions.right = '2px';
            }
            
            return positions;
        },

        getPreviewContainerStyle() {
            const dims = this.paperDimensions[this.config.paperSettings.paperSize];
            if (!dims) return {};
            
            let width = this.config.paperSettings.orientation === 'Landscape' ? dims.height : dims.width;
            let height = this.config.paperSettings.orientation === 'Landscape' ? dims.width : dims.height;
            
            const scale = 0.8;
            const previewWidth = width * scale;
            const previewHeight = height * scale;
            const marginTop = this.config.paperSettings.marginTop * scale;
            const marginLeft = this.config.paperSettings.marginLeft * scale;
            const gap = this.config.paperSettings.horizontalGap * scale;
            
            return {
                display: 'grid',
                gridTemplateColumns: `repeat(${this.calculatedColumns}, 1fr)`,
                gap: `${gap}px`,
                padding: `${marginTop}px ${marginLeft}px`,
                backgroundColor: '#FFF',
                border: '2px solid #333',
                borderRadius: '4px',
                width: `${previewWidth}px`,
                height: `${previewHeight}px`,
                boxSizing: 'border-box',
                margin: '0 auto'
            };
        },

        getPreviewLabelStyle() {
            const scale = 0.8;
            const width = this.config.paperSettings.labelWidth * scale;
            const height = this.config.paperSettings.labelHeight * scale;
            
            return {
                width: `${width}px`,
                height: `${height}px`,
                border: '1px solid #999',
                padding: '2px',
                position: 'relative',
                display: 'block',
                backgroundColor: this.config.labelSettings.backgroundColor,
                borderRadius: '2px',
                overflow: 'visible',
                boxSizing: 'border-box'
            };
        },

        getSingleLabelPreviewStyle() {
            const scale = 3;
            const width = this.config.paperSettings.labelWidth * scale;
            const height = this.config.paperSettings.labelHeight * scale;
            
            return {
                width: `${width}px`,
                height: `${height}px`,
                border: '2px solid #333',
                padding: '0px',
                position: 'relative',
                display: 'block',
                backgroundColor: this.config.labelSettings.backgroundColor,
                borderRadius: '4px',
                overflow: 'visible',
                boxSizing: 'border-box',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            };
        },

        getPreviewContentStyle() {
            const fontWeightMap = {
                'Normal': 'normal',
                'Bold': 'bold'
            };
            
            const positions = this.getPositionByAxis(
                this.config.labelSettings.verticalAlign,
                this.config.labelSettings.horizontalAlign
            );
            
            return {
                position: 'absolute',
                width: `${this.config.labelSettings.contentWidth}%`,
                color: this.config.labelSettings.textColor,
                fontFamily: this.config.labelSettings.fontFamily,
                fontSize: `${this.config.labelSettings.fontSize * 0.5}px`,
                fontWeight: fontWeightMap[this.config.labelSettings.fontWeight],
                fontStyle: this.config.labelSettings.fontStyle,
                lineHeight: '1.2',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                ...positions
            };
        },

        getSinglePreviewContentStyle() {
            const fontWeightMap = {
                'Normal': 'normal',
                'Bold': 'bold'
            };
            
            const positions = this.getPositionByAxis(
                this.config.labelSettings.verticalAlign,
                this.config.labelSettings.horizontalAlign
            );
            
            return {
                position: 'absolute',
                width: `${this.config.labelSettings.contentWidth}%`,
                color: this.config.labelSettings.textColor,
                fontFamily: this.config.labelSettings.fontStyle,
                fontSize: `${this.config.labelSettings.fontSize * 1.5}px`,
                fontWeight: fontWeightMap[this.config.labelSettings.fontWeight],
                fontStyle: fontWeightMap[this.config.labelSettings.fontStyle],
                lineHeight: '1.3',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                ...positions
            };
        },

        fn_saveTemplate() {
            // if (!this.isFormValid) {
            //     this.$notify({
            //         group: 'foo',
            //         title: 'Validation Error',
            //         text: 'Please fill all required fields',
            //         type: 'warn'
            //     });
            //     return;
            // }

            // Save to localStorage for testing
            const templates = JSON.parse(localStorage.getItem('barcodeTemplates') || '[]');
            const existingIndex = templates.findIndex(t => t.name === this.config.name);
            
            let data = {};
            if (existingIndex >= 0) {
                templates[existingIndex] = JSON.parse(JSON.stringify(this.config));
            } else {
                templates.push(JSON.parse(JSON.stringify(this.config)));
            }
            
            localStorage.setItem('barcodeTemplates', JSON.stringify(templates));

            // this.$notify({
            //     group: 'foo',
            //     title: 'Success',
            //     text: `Template "${this.config.name}" saved successfully!`,
            //     type: 'success'
            // });

            // Emit event to parent component
            // this.$emit('template-saved', this.config);

            // Optionally go back
            setTimeout(() => {
                this.fn_goBack();
            }, 1000);
        },

        fn_resetForm() {
            this.config = {
                name: '',
                paperSettings: {
                    paperSize: 'A4',
                    orientation: 'Portrait',
                    marginTop: 10,
                    marginLeft: 10,
                    labelWidth: 38,
                    labelHeight: 21,
                    horizontalGap: 2,
                    verticalGap: 2,
                    labelCount: 65
                },
                labelSettings: {
                    verticalAlign: 'Middle',
                    horizontalAlign: 'Center',
                    contentWidth: 90,
                    fontSize: 10,
                    fontStyle: 'Arial',
                    fontWeight: 'Normal',
                    textColor: '#000000',
                    backgroundColor: '#FFFFFF'
                },
                customFields: []
            };
            this.newField = {
                fieldName: '',
                fieldValue: '',
                layoutDirection: 'Horizontal',
                xAxisAlignment: 'Center',
                yAxisAlignment: 'Center',
                xAxisPosition: 0,
                yAxisPosition: 0,
                posLeft: 0,
                posTop: 0
            };
        },

        fn_goBack() {
            this.$router.go(-1);
        },

        fn_addCustomField(field, imgUri) {
            // if (!this.newField.fieldName || !this.newField.fieldValue) {
            //     this.$notify({
            //         group: 'foo',
            //         title: 'Validation Error',
            //         text: 'Please select a field name and enter a value',
            //         type: 'warn'
            //     });
            //     return;
            // }
            if(field.fieldType == 'image'){
                field.fieldName = 'image_' + this.config.customFields.length;
            }
            else{
                // Check if field already exists
                const exists = this.config.customFields.some(
                    f => f.fieldName === field
                );

                if (exists){
                    this.showToast('Already Exist');
                    return;
                }

                this.newField.fieldName = field;
            }

            
            
            // if (exists) {
            //     this.$notify({
            //         group: 'foo',
            //         title: 'Duplicate Field',
            //         text: 'This field is already added. Remove it first to add again.',
            //         type: 'warn'
            //     });
            //     return;
            // }

            // this.config.customFields.push(JSON.parse(JSON.stringify(this.newField)));

            // this.fn_updatePreview();

            // this.$nextTick(() => {
            //     this.fn_attachDraggableEvents();
            // });

            this.dialogFieldSelection = false;

            if(this.isEditField){
                this.fn_openConfig();
            }
            else{
                this.fn_pushField(imgUri);
            }
        },

        fn_pushField(imgUri){
            this.config.customFields.push(JSON.parse(JSON.stringify(this.newField)));

            this.fn_updatePreview();

            this.$nextTick(() => {
                this.fn_attachDraggableEvents();
            });

            if(this.newField.fieldType == 'image'){
                // let imgContainer = document.createElement('div');
                // imgContainer.classList.add('draggable');
                // imgContainer.style.width = '100%';
                // imgContainer.style.height = 'auto';
                // imgContainer.style.display = 'block';

                setTimeout(() => {
                    let containerElement = document.getElementById('image_'+(this.config.customFields.length - 1)+'_'+this.config.customFields.length);
                    containerElement.innerText = '';
                    let img = document.createElement('img');
                    img.src = "data:image/jpeg;base64," + imgUri;
                    img.style.maxWidth = this.config.paperSettings.labelWidth * 3 * 0.25 + 'px';
                    containerElement.appendChild(img);
                }, 100);

                // document.getElementsByClassName('canvas')[0].appendChild(imgContainer);
            }

            this.fn_resetFieldProperties()
        },

        fn_saveConfig: function(fieldConfig) {
            // let selectedField = this.config.customFields.find(f => f.fieldName === this.newField.fieldName);
            // if (selectedField) {
            //     selectedField.layoutDirection = fieldConfig.verticalLayout ? 'Vertical' : 'Horizontal';
            //     selectedField.fontSize = fieldConfig.fontSize;
            //     selectedField.fontFamily = fieldConfig.fontFamily;
            //     selectedField.fontStyle = fieldConfig.fontItalic ? 'Italic' : 'Normal';
            //     selectedField.fontWeight = fieldConfig.fontBold ? 'Bold' : 'Normal';
            // }

            this.newField.layoutDirection = fieldConfig.verticalLayout ? 'Vertical' : 'Horizontal';
            this.newField.fontSize = fieldConfig.fontSize;
            this.newField.fontFamily = fieldConfig.fontFamily;
            this.newField.fontStyle = fieldConfig.fontItalic ? 'Italic' : 'Normal';
            this.newField.fontWeight = fieldConfig.fontBold ? 'Bold' : 'Normal';
            
            this.$refs['ref_dialogConfig'].closeDialogWeb();
            this.fn_pushField();
            this.fn_updatePreview();
        },

        fn_resetFieldProperties(){
            // Reset form
            this.newField = {
                fieldName: '',
                fieldValue: '',
                layoutDirection: 'Horizontal',
                xAxisAlignment: 'Center',
                yAxisAlignment: 'Center',
                xAxisPosition: 0,
                yAxisPosition: 0,
                posLeft: 0,
                posTop: 0,
                fontSize: 16,
                fontStyle: 'Arial',
                fontWeight: 'Normal',
                textColor: '#000000',
                backgroundColor: '#FFFFFF',
                fieldType:'Label',
                imgWidth:null,
                imgHeight:null,
            };
        },

        fn_attachDraggableEvents() {

            const guideXEl = document.getElementById("guideX");
            const guideYEl = document.getElementById("guideY");

            let showGuideX = null;
            let showGuideY = null;

  let active = null;
  let offsetX = 0;
  let offsetY = 0;
  let holdTimer = null;

  // Cache items OUTSIDE pointermove in real code
    const items = document.querySelectorAll(".draggable");

    let rafId = null;

  // 🔥 MOVE + UP should be GLOBAL (only once)
  document.addEventListener("pointermove", (e) => {
    if (!active) return;

    if (rafId) return;

    rafId = requestAnimationFrame(() => {
        rafId = null;
        // handleDrag(e);
    });

    const parent = active.parentElement;
    const parentRect = parent.getBoundingClientRect();

    // ✅ Use scroll-safe coordinates
    let x = e.clientX - parentRect.left - offsetX;
    let y = e.clientY - parentRect.top  - offsetY;

    // ✅ FIX: adjust for parent borders (important!)
    x -= parent.clientLeft;
    y -= parent.clientTop;

    // ✅ boundaries using client sizes
    const maxX = parent.clientWidth  - active.offsetWidth;
    const maxY = parent.clientHeight - active.offsetHeight;

    x = Math.max(0, Math.min(x, maxX));
    y = Math.max(0, Math.min(y, maxY));
    // let x = e.clientX - parent.getBoundingClientRect().left - offsetX;
    // let y = e.clientY - parent.getBoundingClientRect().top  - offsetY;

    // const maxX = parent.clientWidth  - active.offsetWidth;
    // const maxY = parent.clientHeight - active.offsetHeight;

    // x = Math.max(0, Math.min(x, maxX));
    // y = Math.max(0, Math.min(y, maxY));

    // active.style.left = x + "px";
    // active.style.top  = y + "px";

    active.style.transform = `translate(${x}px, ${y}px)`;

    //  setTimeout(() => {
        if(this.config.customFields && this.config.customFields.length){
            let selectedField = this.config.customFields.find(f => f.fieldName + '_' + (this.config.customFields.indexOf(f) + 1) === e.target.id);
            if (selectedField) {
                selectedField.posLeft = x;
                selectedField.posTop = y;
            }
        }
    // }, 50);

    // Active rect (use NEW position)
    const activeRect = {
        left: x,
        top: y,
        right: x + active.offsetWidth,
        bottom: y + active.offsetHeight,
        centerX: x + active.offsetWidth / 2,
        centerY: y + active.offsetHeight / 2
    };

    let isAnyCollision = false;

    // Vertical guide
    if (showGuideX !== null) {
        guideXEl.style.left = showGuideX + "px";
        guideXEl.style.display = "block";
    } else {
        guideXEl.style.display = "none";
    }

    // Horizontal guide
    if (showGuideY !== null) {
        guideYEl.style.top = showGuideY + "px";
        guideYEl.style.display = "block";
    } else {
        guideYEl.style.display = "none";
    }

    // Remove old collision states first
    items.forEach(el => el.classList.remove("collision"));

    items.forEach(el => {
        if (el === active) return;

        const rect = getRect(el);

        if (isColliding(activeRect, rect)) {
            isAnyCollision = true;

            // Highlight both
            el.classList.add("collision");
            active.classList.add("collision");
        }

        // GUIDE LINES
        const threshold = 5; // px tolerance
        
                // 🔹 LEFT align
        if (Math.abs(activeRect.left - rect.left) < threshold) {
            showGuideX = rect.left;
        }

        // 🔹 RIGHT align
        if (Math.abs(activeRect.right - rect.right) < threshold) {
            showGuideX = rect.right;
        }

        // 🔹 CENTER X align
        if (Math.abs(activeRect.centerX - rect.centerX) < threshold) {
            showGuideX = rect.centerX;
        }

        // 🔹 TOP align
        if (Math.abs(activeRect.top - rect.top) < threshold) {
            showGuideY = rect.top;
        }

        // 🔹 BOTTOM align
        if (Math.abs(activeRect.bottom - rect.bottom) < threshold) {
            showGuideY = rect.bottom;
        }

        // 🔹 CENTER Y align
        if (Math.abs(activeRect.centerY - rect.centerY) < threshold) {
            showGuideY = rect.centerY;
        }
    });
  });

  document.addEventListener("pointerup", () => {
    active = null;
    guideXEl.style.display = "none";
    guideYEl.style.display = "none";
    clearTimeout(holdTimer);
  });

  // 🔥 Attach only pointerdown per element
  document.querySelectorAll(".draggable").forEach(el => {

    el.addEventListener("pointerdown", (e) => {
      e.preventDefault();

      holdTimer = setTimeout(() => {
        active = el;

        const rect = el.getBoundingClientRect();
        offsetX = e.clientX - rect.left;
        offsetY = e.clientY - rect.top;

        el.setPointerCapture(e.pointerId);
      }, 150);
    });

  });
},

        // fn_attachDraggableEvents(){
        //     let active = null;
        //     let offsetX = 0;
        //     let offsetY = 0;

        //     document.querySelectorAll(".draggable").forEach(el => {

        //         let holdTimer;

        //         el.addEventListener("pointerdown", (e) => {
        //              holdTimer = setTimeout(() => {
        //                 active = el;

        //                 offsetX = e.clientX - el.offsetLeft;
        //                 offsetY = e.clientY - el.offsetTop;

        //                 el.setPointerCapture(e.pointerId);  
        //             }, 150); // hold delay
        //         });

        //         el.addEventListener("pointermove", (e) => {
        //             if (!active) return;

        //             // active.style.left = (e.clientX - offsetX) + "px";
        //             // active.style.top  = (e.clientY - offsetY) + "px";
        //             const rect = active.parentElement.getBoundingClientRect();

        //             let x = e.clientX - offsetX;
        //             let y = e.clientY - offsetY;

        //             x = Math.max(0, Math.min(x, rect.width - active.offsetWidth));
        //             y = Math.max(0, Math.min(y, rect.height - active.offsetHeight));

        //             active.style.left = x + "px";
        //             active.style.top  = y + "px";

        //             // setTimeout(() => {
        //             //     if(this.config.customFields && this.config.customFields.length){
        //             //         let selectedField = this.config.customFields.find(f => f.fieldName + '_' + (this.config.customFields.indexOf(f) + 1) === e.target.id);
        //             //         if (selectedField) {
        //             //             selectedField.posLeft = x;
        //             //             selectedField.posTop = y;
        //             //         }
        //             //     }
        //             // }, 50);
        //         });

        //         el.addEventListener("pointerup", (e) => {
        //             clearTimeout(holdTimer);
        //             active = null;
        //             el.releasePointerCapture(e.pointerId);
        //         });

        //     });
        // },

        fn_removeCustomField(index) {
            this.config.customFields.splice(index, 1);
            this.fn_updatePreview();
        },

        getCustomFieldStyle(field) {
            const xPositionMap = {
                'Start': { left: '2px' },
                'Center': { left: '50%', transform: 'translateX(-50%)' },
                'End': { right: '2px' }
            };

            const yPositionMap = {
                'Start': { top: '2px' },
                'Center': { top: '50%', transform: 'translateY(-50%)' },
                'End': { bottom: '2px' }
            };

            // Use numeric position if provided, otherwise use alignment
            let xPos = field.xAxisPosition !== 0 
                ? { left: field.xAxisPosition + 'px' } 
                : xPositionMap[field.xAxisAlignment];
            
            let yPos = field.yAxisPosition !== 0 
                ? { top: field.yAxisPosition + 'px' } 
                : yPositionMap[field.yAxisAlignment];
            
            let transform = '';
            if (xPos.transform && yPos.transform) {
                transform = 'translateX(-50%) translateY(-50%)';
            } else if (xPos.transform) {
                transform = xPos.transform;
            } else if (yPos.transform) {
                transform = yPos.transform;
            }

            return {
                position: 'absolute',
                padding: '1px 2px',
                backgroundColor: '#f9f9f9',
                borderRadius: '1px',
                border: '0.5px solid #ddd',
                fontSize: '7px',
                whiteSpace: 'nowrap',
                writingMode: field.layoutDirection === 'Vertical' ? 'vertical-rl' : 'horizontal-tb',
                textOrientation: field.layoutDirection === 'Vertical' ? 'mixed' : 'initial',
                ...(yPos ? { top: yPos.top, bottom: yPos.bottom } : {}),
                ...(xPos ? { left: xPos.left, right: xPos.right } : {}),
                ...(transform ? { transform } : {})
            };
        },

        getSingleCustomFieldStyle(field) {
            const xPositionMap = {
                'Start': { left: '6px' },
                'Center': { left: '50%', transform: 'translateX(-50%)' },
                'End': { right: '6px' }
            };

            const yPositionMap = {
                'Start': { top: '6px' },
                'Center': { top: '50%', transform: 'translateY(-50%)' },
                'End': { bottom: '6px' }
            };

            // Use numeric position if provided, otherwise use alignment
            // let xPos = field.xAxisPosition !== 0 
            //     ? { left: field.xAxisPosition * 3 + 'px' } 
            //     : xPositionMap[field.xAxisAlignment];
            
            // let xPos = field.xAxisPosition !== 0 
            //     ? { left: field.xAxisPosition + 'px' } 
            //     : xPositionMap[field.xAxisAlignment];

            let xPos = field.posLeft ? { left: field.posLeft + 'px' } : field.xAxisAlignment ? xPositionMap[field.xAxisAlignment] : 0;
            
            // let yPos = field.yAxisPosition !== 0 
            //     ? { top: field.yAxisPosition * 3 + 'px' } 
            //     : yPositionMap[field.yAxisAlignment];

            // let yPos = field.yAxisPosition !== 0 
            //     ? { top: field.yAxisPosition + 'px' } 
            //     : yPositionMap[field.yAxisAlignment];

            let yPos = field.posTop ? { top: field.posTop + 'px' } : field.yAxisAlignment ? yPositionMap[field.yAxisAlignment] : 0;
            
            // let transform = '';
            // if (xPos.transform && yPos.transform) {
            //     transform = 'translateX(-50%) translateY(-50%)';
            // } else if (xPos.transform) {
            //     transform = xPos.transform;
            // } else if (yPos.transform) {
            //     transform = yPos.transform;
            // }

            return {
                position: 'absolute',
                padding: '0px',
                backgroundColor: field.backgroundColor || '#ffffff',
                // borderRadius: '3px',
                // border: '1px solid #ddd',
                fontSize: field.fontSize ? field.fontSize + 'px' : '11px',
                fontFamily: field.fontStyle || 'Arial',
                fontWeight: field.fontWeight || 'normal',
                fontStyle: field.fontStyle || 'normal', 
                color: field.textColor || '#000000',
                whiteSpace: 'nowrap',
                writingMode: field.layoutDirection === 'Vertical' ? 'vertical-rl' : 'horizontal-tb',
                textOrientation: field.layoutDirection === 'Vertical' ? 'mixed' : 'initial',
                ...(yPos ? { top: yPos.top, bottom: yPos.bottom } : {}),
                ...(xPos ? { left: xPos.left, right: xPos.right } : {}),
                // ...(transform ? { transform } : {})
            };
        },
        
        generateBarcode() {
            var JsBarcode = require('jsbarcode');
            JsBarcode("#barcode", "123456789", {
                format: "CODE128",
                width: 2,
                height: 20,
                displayValue: false
            });
        },
        fn_mapFieldValue(fieldName) {
            return this.availableFieldMappings[fieldName] || '';
        },
        fn_openConfig() {
            this.$refs['ref_dialogConfig'].openDialogWeb();
        },
        fn_openPreview() {
            let barcodeFieldIndex = this.config.customFields.findIndex(f => f.fieldName === 'Barcode');
            this.$refs['ref_dialogPreview'].openDialogWeb();
            if (barcodeFieldIndex >= 0) {
                let barcodeElement = document.getElementsByClassName('Barcode')[0];
                
                // Remove existing barcode if already present (avoid duplicates)
                const existing = barcodeElement.querySelector('img.dynamic-barcode');
                if (existing) existing.remove();
                
                let newElement = document.createElement('img');
                newElement.id = 'barcode';
                newElement.classList.add('dynamic-barcode');
                newElement.style.width = '100%';
                newElement.style.height = 'auto';
                newElement.style.display = 'block';

                  // Detect writing mode
                // const styles = window.getComputedStyle(barcodeElement);
                // const writingMode = styles.writingMode;

                // if (writingMode === 'vertical-rl') {
                //     newElement.style.transform = 'rotate(270deg)';
                //     // newElement.style.transformOrigin = 'center';
                //     newElement.style.transformOrigin = 'left top';
                // }

                // barcodeElement.appendChild(newElement);
                barcodeElement.innerText = '';

                const styles = window.getComputedStyle(barcodeElement);
                const writingMode = styles.writingMode;

                if (writingMode === 'vertical-rl') {
                    newElement.style.transform = 'rotate(270deg)';
                    // newElement.style.transformOrigin = 'center';
                    newElement.style.transformOrigin = 'center';
                }

                barcodeElement.appendChild(newElement);
                this.$nextTick(() => {
                    this.generateBarcode();
                });
            }
        },
        fn_openFieldSelection(isEdit) {
            this.dialogFieldSelection = true;
            this.isEditField = isEdit;
        },

        fn_pickImage: function(){
            this.dialogFieldSelection = false;
            let self = this;
            this.$root.fn_checkStoragePermission(function(){
                self.fn_selectFile();
            });
        },

        fn_selectFile: function(){
            let self = this;
            this.getData('PickImage', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.newField.fieldType = 'image';
                        self.fn_addCustomField(self.newField, response);
                        // self.fn_bindImage(response);
                        // self.fn_uploadLogo("data:image/jpeg;base64," + response);
                    },
                    onError: function(error){
                        console.log(error);
                        if(error == 'size limit exceeds'){
                            self.showToast("Max file size limit is 1MB");
                        }
                    }
                }
            );
        },
    },
    mounted() {
        window.js_globals.fn_onBackPress = this.fn_goBack;
        if(localStorage.getItem('barcodeTemplates')) {
            let templates = JSON.parse(localStorage.getItem('barcodeTemplates'));
            if(templates && templates.length) {
                this.config = templates[0]; // Load the first template for editing
                this.$nextTick(() => {
                    this.fn_attachDraggableEvents();
                });
            }
        }
    }
};

function isColliding(a, b) {
  return !(
    a.right  <= b.left - 5 ||
    a.left - 5   >= b.right ||
    a.bottom - 5 <= b.top ||
    a.top    >= b.bottom - 5
  );
}

function getRect(el) {
  return {
    left: el.offsetLeft,
    top: el.offsetTop,
    right: el.offsetLeft + el.offsetWidth,
    bottom: el.offsetTop + el.offsetHeight,
    width: el.offsetWidth,
    height: el.offsetHeight,
    centerX: el.offsetLeft + el.offsetWidth / 2,
    centerY: el.offsetTop + el.offsetHeight / 2
  };
}
</script>

<style scoped>
.canvas, .draggable {
  touch-action: none;
}

.draggable {
  /* position: absolute; */
  /* padding: 10px; */
  /* background: #e3f2fd; */
  cursor: move;
  user-select: none;
  width:fit-content;
}

.draggable.collision {
  outline: 1.5px solid red;
  /* box-shadow: 0 0 8px rgba(255, 0, 0, 0.4); */
  /* border:1px #ff0000 solid; */
}

/* Ruler Wrapper */
.ruler-wrapper {
  display: inline-block;
  position: relative;
  background-color: #fff;
  /* border: 2px solid #333; */
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  background: linear-gradient(to right, #e8e8e8 0%, #f5f5f5 100%);
}

/* Ruler Container */
.ruler {
  position: relative;
  background: linear-gradient(to right, #e8e8e8 0%, #f5f5f5 100%);
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.ruler-x {
  height: 25px;
  border-bottom: 2px solid #999;
  margin-bottom: 2px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  margin-left: 35px; /* Space for Y ruler */
}

.ruler-y {
  width: 35px;
  border-right: 2px solid #999;
  margin-right: 2px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
}

/* Tick Marks */
.tick {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.ruler-x .tick {
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 2px;
}

.ruler-y .tick {
  width: 100%;
  flex-direction: row-reverse;
  justify-content: flex-end;
  padding-right: 2px;
}

.tick-mark {
  background: #333;
}

.ruler-x .tick-mark {
  width: 1px;
  height: 8px;
}

.ruler-y .tick-mark {
  width: 8px;
  height: 1px;
}

.tick-label {
  font-size: 9px;
  font-weight: bold;
  color: #555;
  font-family: 'Courier New', monospace;
  white-space: nowrap;
}

.ruler-x .tick-label {
  padding-top: 1px;
  writing-mode: horizontal-tb;
}

.ruler-y .tick-label {
  padding-right: 3px;
  writing-mode: horizontal-tb;
}

.guide {
  position: absolute;
  background: #4b77be;
  z-index: 9999;
  pointer-events: none;
  display: none;
}

.guide.v {
  width: 1.5px;
  height: 100%;
}

.guide.h {
  height: 1.5px;
  width: 100%;
}

/* .preview-card {
    position: fixed;
    right: 20px;
    top: 80px;
    width: 380px;
    max-height: calc(100vh - 120px);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    z-index: 999;
    overflow-y: auto;
} */

.label-preview-container {
    /* Styles applied via JavaScript */
    box-sizing: border-box;
}

.label-preview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.label-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.label-content p {
    margin: 1px 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

/* @media (max-width: 1200px) {
    .preview-card {
        position: static;
        width: 100%;
        max-height: none;
        margin-top: 20px;
        margin-bottom: 20px;
    }
} */

v-card {
    word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/barcode/barcode_label_config.vue